/**
 * Element - gridGallery
 */

export const gridGallery = ():void => {
  // Run the script for each individual element found on the page
  const elementSelector = document.querySelectorAll('.js-gridGallery') as unknown as HTMLElement[]
  elementSelector.forEach((component:HTMLElement) => {

  })
}
